module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“Got a new case?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ginny Rafferty turned to the cemetery’s caretaker and nodded. The chocolate-brown eyes set deep in the wrinkles of the African-American man’s face looked as old as she felt. “It’s that obvious, John?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With his hands shoved deep into the pockets of his coveralls, he twisted his face into a sympathetic frown. “You make this pilgrimage out here every time you take on an unsolved murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She turned back to the pink granite headstone, with the name Rafferty engraved upon it. “Maybe once I can solve all the rest of them, I’ll get a chance to finally solve hers.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("More than a casual acquaintance, John McBride shared a sad, unique bond with Ginny. He might be one of the few people who understood her need to come to this remote haven nestled between busy Truman Road and Twenty-four Highway time and time again. He shrugged his shoulders and offered a fatherly smile. “It’s gettin’ dark. I’ll have to close the gates soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Give me a couple of minutes. Then I’ll ride down with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("She watched him walk down the hill to his truck, his dignity unbowed by age or sorrow. Everyone coped with ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("loss in his or her own way. Maybe one day she’d move beyond hers and find the acceptance that John seemed to have found.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Until then, she’d maintain her solitary vigil. She’d hang on to the love and loyalty she’d once forsaken in the pursuit of her own misguided dreams. The chilly spring rain drizzled along her cheeks, side by side with the single tear that scorched her skin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The trees that surrounded the hills of Mount Washington Cemetery muffled the sounds of Kansas City at twilight. The haunting silence wrapped her up in its lonely hug, a small comfort for all she had lost.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She understood that the rest of the world moved on, despite her grief. Despite her guilt. But part of her would never understand why.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Twelve years had passed. And she still didn’t understand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("John had become the closest thing she had to a friend over the years. They’d first met the day of her sister’s funeral. He’d been kind enough to let her stay, long after the funeral had ended, long after the guests had departed to a reception at her parents’ Mission Hills home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d been gone a year and a half before that, painting in Europe, losing her heart, learning some harsh truths about life, while Amy learned a harsh truth of her own on a deserted pier in downtown Kansas City.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like this evening, John had waited with her until after dark the night of Amy’s funeral. Then he called for a taxi and paid her fare, even though she had money of her own.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Six months later, she’d lost her mother to a bottleful of the sedatives that were meant to help her cope with the loss of a child. John had been a good friend that day, too. She had needed one. With her father steeped in grief, Ginny had withdrawn to the fringes of the ceremony. An easy enough task for a shy creature like herself. She took a vow that day, ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("made a promise to her sister and her mother. Planned her own quiet rebellion.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("John had found her then, much as she was today, standing in the rain, swearing all kinds of vengeance on the world. He’d told her of his son, an officer in the State Highway Patrol, who’d been slain in the line of duty. He shared his feelings of pride and mourning for his brave son. He truly understood her anger and her loss.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And he inspired her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d met John again last year, finally losing her father to an overworked heart, though emotionally, she’d lost him years earlier. Her parents had never been the same after Amy’s senseless murder. Ginny was a grown woman now—no grief-stricken teen, no rebellious coed—a mature career woman of thirty.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d willingly given up her scholarship to study art in Europe and enrolled in the justice studies program at Central Missouri State University in nearby Warrensburg. She’d taken care of her father, and now she took care of Kansas City, Missouri, too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She sought justice for the innocent victims like her sister. Like her mother and father. And like that poor man this afternoon, buried alive and left to die.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Like a family reunion of battle-scarred survivors, she and John now met at the start of every new case. Each time, he waited patiently to drive her to her car at the front gates. And each time, she made the same promise to her sister and parents.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She spread her palm flat over the cold granite that bore her family’s names and recited her vow. “I’ll find out who did this to us. There will be justice for the Raffertys.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She curled her fingertips into the grooves cut deep into the stone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I promise.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("Ginny headed down the hill toward the road. Her char")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("coal-gray chinos, damp from a day’s worth of rain, stuck to her legs like a second skin and chilled her. The warmth of John’s truck sounded pretty inviting right about now. She really ought to make an effort to cultivate his friendship. He’d always been so kind. But she’d never been very good at that sort of thing. Making friends had always been Amy’s forte. Some day soon—tonight, maybe—she’d overlook her insecurities and take him out to dinner.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Well, maybe not tonight. A telltale chirping vibrated at her hip. Stopping beside the road, she pulled out her cell phone and flipped it open.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Detective Rafferty.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah, Gin. It’s Merle.” She turned her face away from the phone to mask her weary sigh. She and her partner had been on the clock since eight that morning. How could he still sound energetic nearly eleven hours later?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s up?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I got a name on that murder at the Ludlow you asked about. Back in 1989. An eighteen-year-old kid named Mark Bishop.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("That’s not the first dead body I’ve seen at the Ludlow Arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ginny’s own energy kicked up a notch. “Was that case solved?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Merle spoke as if he was reading the information straight off his computer screen. “History of family violence. Died from a blow to the head. The death was attributed to his father, Alvin Bishop. Neighborhood bully. He had a record of abuse and neglect with Social Services, and a string of minor convictions. Everything from drunk and disorderly to assault on the garbage collector.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But no charges were filed?” She sensed more unfinished business.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("“A warrant was issued for the father’s arrest. But he dis")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("appeared before his arraignment. Listed as a missing person ever since.”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So justice was never served.” Either pieces of the puzzle were beginning to fall into place, or she’d opened a box with more pieces than she could count. That body at the morgue could be Alvin Bishop. “Get Mac Taylor at forensics on the line. Tell him to run Bishop’s name through as a possible ID on our John Doe.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Will do.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Anything else?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah.” A twinge of frustration colored his voice. “The statements I took from those two homeless guys, Zeke Jones and Charlie Adkins, are useless.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His frustration just became hers, too. “They didn’t see anything?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who knows? Charlie said nothing, just sat there staring at me. Zeke kept spouting off his name, rank and serial number. I thought I was in the twilight zone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sometimes, witnesses saw a male detective as a threatening presence, and were more apt to open up to a female. She hoped that, and not one of the mental disorders that affected some homeless people, was the case with these guys. “I’ll give it a shot tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks. I’ll get you the address for the shelter where I sent them.” She was just about to hang up when she heard Merle call her name. “Hey, Gin?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She put the phone back to her ear. “Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You have dinner plans?” Ginny rolled her eyes heavenward at the sincere catch in his voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pictured his sweet, unlined face and the gradual aging she saw day by day in his dark green eyes. This wasn’t the first time he’d asked her out. It wouldn’t be the first time she said no, either. “You know how I feel about going out with the men I work with.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("His voice rushed over the line. “Hey, no. I’m your part")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("ner, I’m just worried about you. We missed lunch, remember?”")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I remember.” She forced a smile, as if he could see her relief. “I’ll get something to eat, don’t worry. You get out of that office, too, okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I will.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good night, Merle.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“’Night, Gin.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hung up and dug inside another pocket for a specific slip of paper. A business card. Taylor Construction, Brett Taylor, Owner.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked at the card and pictured the man. Big. Rugged. Smart-mouthed. “Do you always show up when there’s a dead body in the neighborhood?” she asked the image.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Memorizing the number, she hurried to John’s truck and dialed before climbing in.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("John spared her an indulgent smile before putting the truck in gear. “Duty calls, I take it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She nodded through the unanswered rings. “I’ve got an opportunity to ask a few questions I shouldn’t put off.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He wound through the hairpin turns toward the cemetery’s front gates. “One of these days I want you to tell me you’re in a hurry to meet a young man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She smiled. “John, you sound just like my dad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An answering machine picked up. Brett himself had left the recording. Even across transmitted miles of a recorded message, Brett’s basso profundo voice reverberated through her like a mellow jazz tune, at once enervating and intriguing her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She asked him to call her cell number and then hung up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just like that.” John’s amused voice captured her attention.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("He shook a gentle finger at her. “The look on your face ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("when you talked to that man. That’s the look that tells me you’ve got a social life.”")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ginny frowned. “I talked to his machine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He pulled up behind her car and put the truck in Park. “But you’re wishing it was the real thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Please.” Brett Taylor? Social life? Neither phrase was part of her regular vocabulary. “He’s a possible material witness to a murder case, nothing more.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you say so.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I say so.” Her protest sounded vehement, even to her own ears. She tried to come up with a plausible explanation. For John. “Look, I don’t really date much. I’m too caught up in my work.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s important work you do,” he said in a voice of sage experience. “But it isn’t everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For her, it had to be. Relationships were too awkward for her. Many men were threatened by the nature of her job, her devotion to duty. More men lacked the patience to work through her eccentricities, and she’d never developed those most feminine skills that could encourage a man to make the journey with her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And if she should ever meet a man with the patience and fortitude and self-assurance to withstand a relationship with her, she’d run away as fast as she could. She would never put herself in the position of losing someone she cared about again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Maybe John understood that, after all. His weary silence revealed a man who had lived more life than most people his age. He surprised her by reaching across the seat and squeezing her hand. “Don’t take this the wrong way, but I hope I don’t see you again very soon.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She squeezed back, understanding. “Me neither.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RETT PACED")]), _vm._v(" the small confines of his office, turning the mouthpiece away from his impatient sigh while one of his ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("investors grilled him for information about the story he’d seen on the local evening news.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The Ludlow’s still going to be renovated, right, Brett?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brett righted the phone. “No, Mr. Dennehy. That’s the one we’re tearing down, remember? The other buildings are structurally sound. But not the Ludlow Arms.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It was home to a lot of people, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The older man’s wistful tone added another rock onto the load of responsibility Brett carried on his shoulders. “I know, sir. Hopefully the refurbished buildings will draw quality tenants like yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bill Dennehy perked up as a new thought hit him. “Do you think that body was in the basement when Alice and I were living there?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t think so.” Bill had been lucky enough to live in the Ludlow Arms during the building’s heyday. He knew these streets the way Brett’s grandparents had known it. Thriving. Friendly. Safe. “Trust me. A little bad press isn’t going to stop me from renovating the neighborhood.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Alice won’t come to that fund-raiser of yours if there’s any more news like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course not, but…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He felt a tap at his shoulder and stopped midprotest. Five perfectly shaped, copper-tinted nails reached for the phone. His gaze dropped to the half-amused smile on the mouth of the tall brunette beside him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll handle this. You pace.” She nudged Brett to one side and turned her attention to the caller. “Mr. Dennehy. Sophie Bishop. Yes, I remember you from the old neighborhood…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brett’s frustration turned to admiration as he watched his old friend work Bill Dennehy through a trip down memory lane and onto the road toward a charitable donation. He sat back in the chair behind his desk and watched her do her thing.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d hired Sophie for her expertise in fund-raising and public relations. He could only afford to pay her peanuts, but she’d been quick to volunteer her time. She, too, came from the Market Street area of Kansas City, and seemed as eager to see a rebirth of the community as he was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Things were a little awkward between them, but he hoped she’d moved past their broken relationship. No longer the adoring young college student he’d once dated as a favor to her brother, she’d matured into a powerful, successful woman of the world. And she put her money where her work was. Sophie had been the first to sign up for one of the luxury condos he planned to put in the Peabody Building. Surely that kind of support was proof that they could still work together as old friends.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mr. Dennehy, that’s sweet.” It wasn’t as if Sophie had to be any man’s charity date. With long, shapely legs that stopped somewhere just short of her neck, and the sleek, sculpted features of a fashion model, she’d draw any man’s attention. But Brett looked at her and saw…Mark’s sister.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His feelings for her weren’t all that different from what he felt for his own sister, Jessie. Just as strong, just as protective, just as pure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He rolled his chair up to the desk and leaned his elbows on top, watching with pride and gratitude as she smoothed over the investor’s concern. “I’ll be sure we have a corsage for her at the fund-raising ball. I look forward to seeing you and Mrs. Dennehy there. Bye now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She pressed the off button and handed over the phone with a flourish that made Brett throw his hands up in surrender. “Okay, so you saved my butt. Go ahead and gloat.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("“I’m just doing my job, big boy,” she laughed. She perched on the corner of his desk and tugged the hem of her taupe silk suit down to within inches of her knees. Brett sat back and waited for the rebuke. “Next time there’s a ")]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_vm._v("publicity glitch like this, call me. Don’t wait for me to see it on the evening news.”")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He was my third call tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sophie shook her head, making light of his doubt. “We can use this in our favor. Murder’s the kind of thing that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("used")]), _vm._v(" to happen in this neighborhood. But no more. Not with Brett Taylor on the job, transforming the dark alleys and dangerous streets into a place where families can work and kids can play.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brett frowned and pushed to his feet, uncomfortable with the heroic status, even if it was said in a teasing vein. He walked around the desk and picked up her cashmere stole. “You’d better hit the road. I’m keeping you from your date.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sophie grabbed her purse and joined him. She turned her back to him and let him wrap her shoulders in the oversize scarf. He closed his arms briefly in a friendly hug. “Thanks, kiddo. I owe you one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know. I’m keeping tabs.” A knock on the office door gave Brett the excuse to pull away. Sophie used the opportunity to pull on a pair of leather driving gloves. “Expecting any reporters?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.” Maybe he was looking forward to this next visitor just a little too much. Heedless that Sophie followed him, he hurried through the outer office and opened the trailer door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ginny Rafferty stood outside. The harsh glare of the porch light softened in the silver shimmer of her hair. He released his anxiety on a single breath and let his features relax into a genuine smile. Her crossed arms bespoke all business, but he appreciated her sunny beauty like a breath of fresh air. And the challenging glint in those cobalt eyes stirred his thoughts away from spooked investors and a budget that wouldn’t balance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You said to meet you here,” she said in greeting.")])]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Those blue eyes shuttered and darted to the side before he heard the voice beside him. “Brett?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stepped back, feeling ridiculously jarred by Sophie’s intrusion. The contrast between the two women rendered him silent for a moment. Tall and petite. Dark and fair. Smiling expectantly and expressionless.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Fortunately, Sophie had the sense to see him past the awkward moment. She extended her hand in polite greeting. “I’m Sophie Bishop, an old friend of Brett’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ginny shook hands. “I’m Ginny Rafferty. I’m a—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“New friend,” he interrupted before she could rattle off her official job and title. Sophie had done enough for one night. He didn’t need her to run interference for a police investigation. He didn’t want anyone to interfere with a chance to talk to Ginny. “Soph does public relations for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I see,” said Ginny.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well…” Sophie smiled and excused herself. “I’d best not keep Eric waiting. I’ll call you in the morning to touch base.” With a tilt of her chin, she leaned in and kissed Brett’s cheek, then wiped the spot with her thumb as if she had left a mark of lipstick. “Good night.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good night.” Brett squeezed her arm affectionately, and watched her until she climbed into her car and pulled away from the curb.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Only then did he realize that Ginny was still standing on the porch, waiting to be invited in. Brett wiped at his cheek, as if Sophie’s kiss was still visible, and concentrated on the woman before him. He stepped aside and held the door open for her. “Ms. Rafferty.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He rolled her name around his tongue like a piece of candy. He ought to be on a first-name basis with this woman, call her Gin—or Angel, a compliment to her looks she wouldn’t want to hear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At least, not from him.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she stepped over the threshold, he noted the trappings of her trade, a blue plaid blazer that masked the bulk of a gun and badge at her waist. When she walked past him, tantalizing as a breeze of fresh air, he noticed her stiff posture and the cool expression on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He set aside the inexplicable desire to hear her loosen up and laugh just once, and followed her into his office. He hadn’t worried about the mess before with Sophie. But when Ginny picked up an untouched sack of fast food off the chair, he wished he’d taken time to clean up the place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She dangled the bag between her thumb and middle finger, eyeing the grease spot that had soaked through the brown paper. “Did I interrupt dinner?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That was lunch.” He took the bag from her to throw away—once he located the trash can. He spotted it, supporting one corner of the scale model of the revamped city block where the Ludlow, Walton and Peabody Buildings sat. “Yesterday’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She perched on the very edge of the chair once it had been cleared. He lifted a corner of plywood and ditched the day-old food.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you spend a lot of time in your office?” she asked. He could almost read the phrase "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bachelor pad")]), _vm._v(" on her lips, and wished he could show her the clean, uncluttered space of his condo that he’d designed and remodeled himself in a nearby warehouse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("He pulled out his own chair and sat across the desk from her. So it was to be strictly business between them. Again. Thinking of the waste of those beautiful, expressive eyes of hers, when they could be sparkling with laughter or drowsy with passion instead of so cold with single-minded determination, he tried to accommodate. “I do the paperwork here. But mostly I’m out on the work sites. Lately, I’ve been conned into attending some fund-raising events. I’m working ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("toward three million to rebuild the Ludlow block the way I want to.”")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Three million, hmm?” Her ever-watchful eyes continued to scan the office. “I think you’d be a natural at schmoozing people for money.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ouch. Though the comment was superficially complimentary, her tone of voice gave her words a condemning twist.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Feeling the unjust sting of failure, he pushed to his feet and circled the desk. He couldn’t let her taunt—intentional or otherwise—go unchallenged. He shoved aside a stack of bills and sat on the edge, right in front of her. Close enough that his knee brushed hers when he crossed his legs at the ankle. He ignored the traitorous rush of heat that shot toward his toes at that slightest of contacts. He crossed his arms in front of his chest and flexed his muscles in his most intimidating display of force.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m doing a good deed here, angel. At best, I’ll break even. Any profit I might end up with will be reinvested in future projects to improve the neighborhood.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Undaunted by his face-saving attack, she tipped her chin and looked straight up into his eyes. “You seem to have several projects in mind, Mr. Taylor. You’re quite the philanthropist. How much money have you raised so far?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Damn, she was a cool customer. Instead of taking offense, the blood surged through Brett’s veins at her show of strength. Why the hell did he have to get twisted up inside over this pint-size bundle of woman who was all backbone and beautiful eyes? He was a healthy male, more than decently attractive, according to the women he’d dated. He knew his manners and how to make a woman laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And yet this one, Ginny Rafferty, with the Nordic looks and Arctic demeanor, got under his skin. The one woman whose only interest in him applied to whatever information he could give her in a murder investigation, fascinated the hell out of him.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He liked the challenge of sparring with her. He’d like it even better if he knew this battle of wills was leading someplace interesting. “We’re halfway there. We’ve pledged about one million in donations. And I put up half a million of my own money.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Really.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One elegant eyebrow, a darker shade of blond than her silvery hair, arched above her skeptical gaze. He felt her scrutiny from the shoulders of his worn flannel shirt to the toes of his scuffed work boots. He seemed to fall short, in her opinion, judging by the doubt etched on her face, an observation that rankled his male ego. He’d butted heads with beautiful women before, and had never failed to charm his way into their good graces.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Ginny was different. She didn’t play the game at which he excelled. With her, the battle of wills was for real.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brett couldn’t help but defend himself. “My business is successful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I wasn’t accusing you of lying.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then what "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" you accusing me of?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His taunt seemed to strike a nerve in her. She averted her face and blew out her breath on a long sigh. In the space of a heartbeat, Brett’s adversarial instincts switched to an uncomfortable mix of guilt and concern. She rose to her feet, a coordinated series of movements blending grace and control.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Regretting his self-serving need to strike back, to assert himself, Brett chose to remain seated. She stood beside him, not quite face-to-face, and he could see the ultrafine spider-web of bluish veins beneath the pale porcelain of her skin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He curled his fingers into his palms, combatting the urge to touch her, to see if her cheek was as smooth and soft and fragile as it looked. He’d forgotten her job for the moment, given vent to his frustration. He’d simply reacted. Without much thought or consideration of the consequences.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How much do you stand to lose if the Ludlow project fails?” She didn’t look at him until she’d finished the question.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When he turned his face to her, he nearly sank to the floor. Eye-to-eye, mere inches away, he felt the gentle heat of her reaching out to him like a tentative caress.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He must be tired and imagining things, he thought. He’d seen those eyes cool and blank. He’d seen them wide and dark with fear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But he’d never seen them as he did now. The tiniest of frowns made a shallow dent between her eyebrows, and her eyes gleamed with a warmth that reminded him of sunshine streaming in through a stained-glass window.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The uncustomary openness in her expression triggered an unexpected response inside him, a desire to be equally frank, without sugarcoating the truth with a smile or a clever joke.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I could lose my shirt, if I’m not careful. If this project fails and I have to repay my investors on top of the accumulated debt, I’ll go bankrupt. Taylor Construction would be no more.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What about your personal assets?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His family suspected he was in this building campaign up to his eyeballs, but he’d never shared the extent of what he had laid on the table to make this reclamation project happen. But alone in his office with the bright-eyed detective, the words spilled out. “I could lose everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She uttered a sound like a gasp of disbelief, then turned and paced to the far end of the room. When she spun around, Brett sat up straighter. That brief glimpse of compassion he’d imagined had vanished. She was primed for battle again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then why do this? Why not take the renovation one building at a time?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He took the offensive, standing and bracing his hands on his hips. “Are you investigating me or the murder?”")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is personal for you, isn’t it?” She walked closer, each step a brick of suspicion building against him on some unknown case. “Does this have anything to do with Mark Bishop’s death?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brett turned his face to the ceiling and swore. When he looked at her again, he didn’t bother softening the blow. She hadn’t pulled any punches, and neither would he. “You got a lot of nerve, lady.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I understand Mark Bishop was a friend of yours.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook his head, admiring her gall, if not her choice of topic. “That woman you just met was his sister. The Bishops were like family to me.” A defensive edge slipped into his voice. He didn’t try to mask it. “I met Mark through the Big Brother program. He was a good kid who needed a break. I tried to give him one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What can you tell me about his death?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Somebody beat the hell out of him, then left him without any medical attention. Why do you want to know?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That body in the basement could be Mark and Sophie’s father, Alvin Bishop.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hell.” He collapsed back onto the desk. “Are you sure?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t have the forensics yet, but the timeline fits. It’s a possibility.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It seemed impossible. To hear that name again. Twelve years after the man got away with murder…or maybe he hadn’t, after all. Brett looked Ginny square in the eye. Her phone message had said she wanted to discuss the case. But which one?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He schooled what was left of his patience and asked, “Just what is it you want from me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you have any idea who’d want to kill Alvin Bishop?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Me, for one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Brett.”")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He liked the sound of his name in her crisp, clean voice, even if it was couched in a reprimand. But she’d made it more than clear that he was just a means to an end of a case for her. Keeping that sobering thought in mind, he answered, “Just about anybody in town back then. He wasn’t a nice guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She moved a step closer, folding her hands together and beseeching him in an unconscious gesture that he found difficult to ignore. “Mac says you know more about the neighborhood’s history than anyone. Records about the Ludlow tenants are sketchy and outdated. Do you think you could give me some specifics?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The intelligent gleam in those dark blue eyes never wavered. “You’re serious, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m investigating a murder. I’m always serious.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He could see that. “All right, then. But not on an empty stomach.” Her challenge galvanized him. Shoving himself to his feet, he grabbed his keys from the desk and strode toward the door. “I haven’t eaten since breakfast, and it’s past nine o’clock. I need to fuel up if I’m going to do this right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ginny hurried after him in quicker, shorter strides. “What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged his shoulders. “I mean I’m hungry. I’m going to go eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Now?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He pushed the door and held it open for her, amused by the incredulity of her question. Once she was outside, he closed and locked it behind him. “That’s the general idea.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He heard a rapid rush of air behind him. “I’m just getting started. There’s more I need to ask.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I figured you’d come with me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("He swept his arm out, indicating she precede him down the stairs. Instead, she took a step back against the iron rail")]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("ing. Maybe it was a trick of the overhead light, but her already fair skin blanched to an unhealthy shade of pale.")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Brett reached out and touched her shoulder. “You all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For an instant, time suspended itself between them. But before he could question her jumpy reaction, Ginny shrugged away his fingers and bolted down the steps. He could tell by her hushed tones that she’d dropped him from the conversation. “I’ll look up the names of some of the longtime residents of this part of the city. Maybe I can get them to talk. Forensics alone won’t tell me why that man was buried alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Time out.” He caught up to her in three long strides, and coiled his hand around her upper arm, holding on when she would have pulled away again. “I didn’t say anything about not talking. You stirred up some ghosts when you mentioned Mark and Alvin Bishop. I want to be sure I’m thinking clearly. I don’t want to make a mistake about either death.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beneath the coiled tension of sleek muscles, he felt…trembling. He glanced from his hand up into the smooth perfection of her face. Cool and rock-solid as always, she revealed no emotion. But the fine tremors didn’t lie. Something made her nervous. Had he startled her? Or was it the fact that he refused to let go?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was torn between putting her at ease and demanding to know why she’d so easily dismiss his help. Conscience beat curiosity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Look, my uncle was a cop. My cousin Mitch, your boss, is captain of the local precinct. I have three brothers who are in law enforcement or criminal investigation. A fourth who used to be. It’d be suicide at family reunions if I didn’t help a cop when she asked me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No laugh.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_vm._v("Shrugging off his inability to coax even a smile from her, ")]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("he released her. She backed off a step and buried her hands in the pockets of her blazer.")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The older a case is, the harder it is to solve,” she said, as if explaining her aversion to his touch. “If I don’t have your full cooperation, then this is pointless.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ll find out the truth. Together.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With the challenge hanging in the air, he dared her to retreat a third time. Her gaze darted from the sidewalk to her car and back to the middle of his chest. “All right. We’ll eat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He rewarded her hard-won agreement with a smile, overlooking the bothersome observation that she hadn’t looked him in the eye. “There’s a diner on the next block. Since the rain stopped, we can walk.” Keeping a comfortable distance between them, Brett headed for the corner, shortening his stride so Ginny didn’t have to pump her legs in double time to keep up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I suppose it makes good sense.” She seemed intent on reasoning this out. “I need background. You need to eat. We can combine both and save some time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“See? It’s a good plan all round. Not bad for an arrogant bozo like me, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I didn’t say…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He sensed the snap of her head as she looked up at him. He came to an abrupt stop and turned. Whatever she was about to say died on her lips when their gazes met. She didn’t know he’d been teasing! She would have defended him against the self-mocking insult.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_vm._v("Big bad Brett Taylor, neighborhood hero and resident handyman, had always taken care of himself and those around him. To know this dainty bit of curves and confidence had been willing to do the same for him warmed a chilly place inside he hadn’t acknowledged for a long time. Ginny Rafferty wasn’t quite the all-business woman who ")]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_vm._v("fascinated him. She was human. The woman was as much of a mystery as the cases she worked to solve.")])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reaching an unspoken truce of sorts, he checked for traffic, took her by the elbow and crossed the street with her. He released her as soon as they were safely across. “If we can prove that old man Bishop finally got what he deserved, I’ll answer any question you have, as many times as you want to hear it. There are plenty of folks around here who would love to know the truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“One thing I’ve learned, working homicide…” He glanced down to see the wry wisdom in her voice reflected in the expression on her pretty face. “There’s always one person who doesn’t want you to find out the truth.”")])])]), _c('a', {
    attrs: {
      "id": "page44"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page44"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d322554","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/suddenengagement_ch02.vue
// module id = 87
// module chunks = 0